import ArchiveFiltersController from '../ArchiveFiltersController';
import type { ArchiveFilterModule } from '../types';

class TagsFilter implements ArchiveFilterModule {
    private controller: ArchiveFiltersController | null = null;
    private tagButtons: NodeListOf<HTMLButtonElement> | null = null;
    private tagContainer: HTMLElement | null = null;
    private selectedTag: string | null = null;

    public mount(controller: ArchiveFiltersController): void {
        this.controller = controller;
        this.init();
    }

    private init(): void {
        this.tagContainer = document.querySelector('[data-tags]');
        this.tagButtons = document.querySelectorAll('[data-tag]');

        if (!this.tagButtons.length) {
            return;
        }

        if (!this.controller) {
            return;
        }

        const controller = this.controller;

        this.initializeActiveTag();
        this.bindTagEvents();

        controller.onStateChange((state) => {
            this.syncTagButtons(controller.usesSchoolFilter() ? state.school : state.post_tag);
        });
    }

    private initializeActiveTag(): void {
        if (!this.tagButtons) {
            return;
        }

        this.selectedTag = this.controller?.getActiveTagFilter() ?? null;
        this.syncTagButtons(this.selectedTag);
    }

    private bindTagEvents(): void {
        if (!this.tagContainer) {
            return;
        }

        this.tagContainer.addEventListener('click', (event) => {
            event.preventDefault();

            const target = event.target;

            if (!(target instanceof HTMLElement)) {
                return;
            }

            const button = target.closest('button[data-tag]');

            if (!button) {
                return;
            }

            const id = button.getAttribute('data-tag');
            const type = button.getAttribute('data-type');

            if (type === 'school') {
                this.selectSchool(id);
            } else {
                this.selectTag(id);
            }
        });
    }

    private selectTag(tagId: string | null): void {
        this.selectedTag = tagId;
        this.syncTagButtons(tagId);
        this.controller?.setPostTag(tagId);
    }

    private selectSchool(schoolId: string | null): void {
        this.selectedTag = schoolId;
        this.syncTagButtons(schoolId);
        this.controller?.setSchool(schoolId);
    }

    private syncTagButtons(tagId: string | null): void {
        if (!this.tagButtons) {
            return;
        }

        this.tagButtons.forEach((button) => {
            const buttonTagId = button.getAttribute('data-tag');

            if (buttonTagId === tagId) {
                button.classList.add('active');
            } else {
                button.classList.remove('active');
            }
        });
    }
}

export default TagsFilter;